import { render, staticRenderFns } from "./CreateStep.vue?vue&type=template&id=0b99af3a&scoped=true&"
import script from "./CreateStep.vue?vue&type=script&lang=js&"
export * from "./CreateStep.vue?vue&type=script&lang=js&"
import style0 from "./CreateStep.vue?vue&type=style&index=0&id=0b99af3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99af3a",
  null
  
)

export default component.exports